import React from 'react';
import { NodeResizer } from 'reactflow';
import BaseScadaNode from './BaseScadaNode';

export default function LineArrowNode(props) {
    const { data, selected, width: nodeW, height: nodeH } = props;
    const config = data?.config || {};
    const w = nodeW || data?.width || 80;
    const h = nodeH || data?.height || 20;
    const color = config.color || '#475569';
    const thickness = config.thickness || 2;
    const cy = h / 2;
    const arrowSize = Math.max(6, thickness * 3);

    return (
        <BaseScadaNode {...props}>
            {data?.isEditMode && (
                <NodeResizer isVisible={selected} minWidth={20} minHeight={10}
                    lineStyle={{ border: '1.5px solid #4F46E5' }}
                    handleStyle={{ width: 8, height: 8, background: '#4F46E5', border: '1px solid #818CF8', borderRadius: 2 }} />
            )}
            <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} style={{ display: 'block' }}>
                <defs>
                    <marker id={`arrow_${w}_${h}`} markerWidth={arrowSize} markerHeight={arrowSize} refX={arrowSize - 1} refY={arrowSize / 2} orient="auto">
                        <polygon points={`0 0, ${arrowSize} ${arrowSize / 2}, 0 ${arrowSize}`} fill={color} />
                    </marker>
                </defs>
                <line
                    x1={4} y1={cy}
                    x2={w - arrowSize - 2} y2={cy}
                    stroke={color}
                    strokeWidth={thickness}
                    markerEnd={`url(#arrow_${w}_${h})`}
                    strokeDasharray={config.dashed ? '6 4' : undefined}
                />
            </svg>
        </BaseScadaNode>
    );
}
